import { TValidator } from './types';

export const multipleOptionsRange = (min: number, max: number): TValidator => (values: string[]) => {
  if (!values) {
    return undefined;
  }

  if (!Array.isArray(values)) {
    return 'Unable to validate as provided value is not an array';
  }

  if (values.length > max || values.length < min) {
    return `Number of options not in range of <${min}, ${max}>`;
  }

  return undefined;
};
